import { z } from "zod";
import { ObjectMeta } from "../../common";

export const DesignElementOrigin = z.object({
  id: z.string(),
  sourceId: z.string(),
  name: z.string(),
});

export const DesignElementBase = z.object({
  id: z.string(),
  persistentId: z.string(),
  meta: ObjectMeta,
  designSystemVersionId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const DesignElementImportedBase = DesignElementBase.extend({
  origin: DesignElementOrigin,
});

export const DesignElementGroupablePart = z.object({
  parentPersistentId: z.string().optional(),
  sortOrder: z.number(),
});

export const DesignElementGroupableBase = DesignElementBase.extend(DesignElementGroupablePart.shape);

export const DesignElementGroupableRequiredPart = DesignElementGroupablePart.extend({
  parentPersistentId: z.string(),
});

export const DesignElementBrandedPart = z.object({
  brandPersistentId: z.string(),
});

export const DesignElementSlugPart = z.object({
  slug: z.string().optional(),
  userSlug: z.string().optional(),
});

export type DesignElementOrigin = z.infer<typeof DesignElementOrigin>;
export type DesignElementBase = z.infer<typeof DesignElementBase>;
export type DesignElementGroupablePart = z.infer<typeof DesignElementGroupablePart>;
export type DesignElementGroupableBase = z.infer<typeof DesignElementGroupableBase>;
export type DesignElementGroupableRequiredPart = z.infer<typeof DesignElementGroupableRequiredPart>;
export type DesignElementBrandedPart = z.infer<typeof DesignElementBrandedPart>;
export type DesignElementSlugPart = z.infer<typeof DesignElementSlugPart>;
